import {
  FaBriefcase,
  FaCode,
  FaGithub,
  FaGlobe,
  FaGraduationCap,
  FaLink,
  FaLinkedin,
  FaProjectDiagram,
  FaUser,
} from "react-icons/fa";
import { GrContact } from "react-icons/gr";
import { IoLanguageOutline } from "react-icons/io5";

export const personalInformation = {
  name: "Samrat Ojha",
  role: "Software Engineer",
  location: "Kastrup, Denmark",
  email: "samratojha91011@gmail.com",
  phone: "+45 71327961",
  summary:
    "Software Engineer and MSc Computer Science student at Technical University of Denmark (DTU) with over 3 years of professional experience in high-performance web development. I specialize in building scalable, data-driven applications, having architected financial tools and CRM systems used by thousands. My technical background is complemented by a Master's specialization in Artificial Intelligence and Algorithms, allowing me to solve complex engineering problems with efficient, modern solutions.",
  links: [
    {
      label: "LinkedIn",
      url: "https://www.linkedin.com/in/samrat166",
      icon: FaLinkedin,
    },
    { label: "GitHub", url: "https://github.com/samrat166", icon: FaGithub },
    { label: "Website", url: "https://samratojha.com.np/", icon: FaGlobe },
  ],
};

export const menuItems = [
  { id: "about", label: "About", icon: <FaUser /> },
  { id: "experience", label: "Experience", icon: <FaBriefcase /> },
  { id: "projects", label: "Projects", icon: <FaProjectDiagram /> },
  { id: "education", label: "Education", icon: <FaGraduationCap /> },
  { id: "skills", label: "Skills", icon: <FaCode /> },
  { id: "language", label: "Language", icon: <IoLanguageOutline /> },
  { id: "contact", label: "Contact", icon: <GrContact /> },
];

export const workExperience = [
  {
    role: "Frontend Developer",
    company: "Costbits, Denmark",
    date: "August 2025 - December 2025",
    desc: "Contributing to a platform designed to improve how companies manage their buying process and sustainability goals. My main focus is developing clean and modular frontend components using React and Tailwind CSS. I work closely with .NET developers to connect the user interface with the backend, making sure data-heavy features are fast and reliable.",
    tech: [
      "React",
      "TypeScript",
      ".NET",
      "PostgreSQL",
      "Tailwind CSS",
      "Clean Architecture",
      "Modular Design",
    ],
  },
  {
    role: "Full Stack Developer",
    company: "Cloud Masters Pvt Ltd, Biratnager, Nepal",
    date: "November 2022 - January 2025",
    desc: "Responsible for building full-stack web applications from initial design to final launch using Agile development practices. I developed both user-facing interfaces and backend logic, ensuring applications were reliable and easy to use. My role included fixing bugs, deploying apps to cloud platforms, and meeting with clients to turn their requirements into technical solutions. I also led daily stand-ups and mentored interns to help the team meet sprint goals.",
    tech: [
      "React.js",
      "Node.js",
      "MongoDB",
      "Express.js",
      "Redis",
      "Google Drive API",
      "DigitalOcean",
      "Zoom API",
      "Bootstrap",
    ],
  },
  {
    role: "Freelance MERN Developer",
    company: "Self-Employed",
    date: "October 2021 - February 2022",
    desc: "Worked as an independent developer to create three different web apps for schools and local services. I handled everything myself, including the design, building the database, and making sure the apps worked well on the internet.",
    tech: [
      "React.js",
      "Node.js",
      "Express.js",
      "MongoDB",
      "Cloudinary",
      "Bootstrap.js",
      "Tailwind CSS",
      "Netlify",
    ],
  },
];

export const internshipsAndTraining = [
  {
    role: "Full Stack Web Development Intern",
    company: "Hash Technologies, Biratnagar",
    date: "June - August 2021",
    desc: "Learned how to build modern web applications using the MERN stack. I practiced building both the front and back parts of apps and worked with a team to make sure our code was high quality and worked fast.",
    tech: ["React.js", "Node.js", "Full-stack Design", "MongoDB", "Express.js"],
  },
  {
    role: "Django (Python) Web Development Training",
    company: "Nihareeka College, Nepal",
    date: "Feb - March 2019",
    desc: "Took a special course to learn how to use Python and Django to build websites. I learned how to set up projects, create web pages, and manage how data is saved and shown to users.",
    tech: ["Python", "Django", "Django Templates", "Backend Logic"],
  },
];
export const companyProjects = [
  {
    title: "Costbits Platform",
    url: "https://costbits.com/",
    desc: "A professional platform built with React, TypeScript, and Tailwind CSS to help companies manage their buying process and keep track of spending. The development focuses on creating clear screens that turn complex financial data into simple tools. It integrates with a .NET and PostgreSQL backend to ensure the site remains fast and reliable for business users.",
  },
  {
    title: "Ethica Finance & CRM",
    url: "https://app.ethica.finance/",
    desc: "This project involved the development of two separate systems using the MERN stack. The first is a wealth management tool for customers to track investments, while the second is Ethica CRM, a business portal designed to manage customer invoices and schedules. To provide a seamless experience, several third-party services like Zoom, Google Drive, and the WhatsApp API (via Twilio) were integrated directly into the platform. This allows users to manage meetings, share documents, and communicate with clients without ever having to leave the application.",
  },
  {
    title: "MHC Housing Service",
    url: "https://mhccrm.com/",
    desc: "An operations tool built using React and Node.js to help mobile home manufacturers manage their business workflow. It organizes customer records and inventory while using the Google Maps API to track home deliveries in real-time. The application simplifies daily tasks such as handling service requests and managing stock levels efficiently.",
  },
  {
    title: "Nihareeka College Website",
    url: "https://nihareekacollege.edu.np/",
    desc: "The official web portal and management system for Nihareeka College, developed using React and Node.js. It features a public side for news and events, alongside a private admin dashboard that allows staff to manage student inquiries and academic notices.",
  },
];

export const hobbyProjects = [
  {
    title: "Gankpls",
    url: "https://www.gankpls.gg/",
    desc: "A community platform for League of Legends players built with Next.js and NextAuth for secure user sessions. It features an AI team generator powered by the OpenAI API and pulls real-time data using the Riot Games API. The site allows players to create posts to find teammates and uses specialized filtering to connect users across different regions.",
  },
  {
    title: "Game of Digits",
    url: "https://www.gameofdigits.online/",
    desc: "A fast-paced reflex game developed as a Next.js application to test reaction speeds. The goal is to tap the screen to stop a moving counter on an exact target number. The game is optimized for high performance on both mobile and desktop browsers, providing a smooth and addictive user experience through clean CSS and JavaScript logic.",
  },
];
export const education = [
  {
    school: "Technical University of Denmark",
    degree: "Masters in Computer Science & Engineering",
    date: "Present",
    loc: "Lyngby, Denmark",
  },
  {
    school: "Tribhuvan University",
    degree: "B.Sc. Computer Science and Information Technology",
    date: "2018 - 2022",
    loc: "Nepal",
  },
];

export const skills = {
  languages: ["JavaScript", "TypeScript", "Python"],
  frontend: [
    "Next.js",
    "React.js",
    "Tailwind CSS",
    "Chakra UI",
    "Bootstrap",
    "Redux",
    "HTML5",
    "CSS3",
  ],
  backend: ["Node.js", "Express.js", "Django", "REST APIs", "NextAuth"],
  database: ["MongoDB", "PostgreSQL", "Redis", "Mongoose"],
  cloud_devops: ["DigitalOcean", "Git/GitHub", "Vercel", "Netlify", "Heroku"],
  integrations: [
    "OpenAI API",
    "Riot API",
    "Google Maps API",
    "Zoom API",
    "Twilio (WhatsApp)",
    "Stripe",
  ],
};

export const languages = [
  { name: "Nepali", level: "Native", strength: 100 },
  { name: "English", level: "Professional / Fluent", strength: 95 },
  { name: "Hindi", level: "Fluent", strength: 90 },
  { name: "Danish", level: "Beginner", strength: 15 },
];
